import React from "react"

import { useSelector } from "react-redux"
import QRcode from "./QRcode"
import QRcodeWelcomeMessageSV from "./QRcodeWelcomeMessageSV"

const PatientSV = () => {

    const listItems = useSelector(store => store.reply.patientData)

    return (
        <>  
            <h1 className="title">Summary Questionnaire data</h1>
            <QRcodeWelcomeMessageSV />
            <QRcode />
            
            {listItems.map((item) => (
            <div className="patients" key={item._id}>

                <div> <span className="time-info">submitted: </span>{String(item.createdAt).split('T')[0]}</div>
                <h2 className="subtitle">Allmänna frågor</h2>

                <div className="time"> {item.createdAt}</div>



                <div><span className="basic-info">username: </span> 
                    {item.username}
                </div>

                <div><span className="basic-info">ålder: </span>
                    {item.age}
                </div>

                <div><span className="basic-info">kön: </span> 
                    {item.gender}
                </div>

                <div><span className="basic-info">diabetes typ: </span> 
                    {item.diabetesType}
                </div>

                <div><span className="basic-info">I vilken region/ stad bor du?</span> 
                    {item.q1}
                </div>

                <div><span className="basic-info">När, vilket år, fick du diagnosen diabetes?</span> 
                    {item.diagnosisYear}
                </div>

                <div><span className="basic-questions">Hur hanterar du diabetes nu? t.ex. insulin, 
                        medicin, kosttillskott, kost, motion. 
                        Beskriv gärna i detalj.</span>
                    <div className="answers">
                        {item.q2}
                    </div> 
                </div>

                <div><span className="basic-questions">Hur ofta kontrollerar du dina blodsockernivåer?</span>
                    <div className="answers">
                        {item.q3}
                    </div>
                </div>

                <div><span className="basic-questions">Vad är den mest utmanande aspekten med att ha diabetes?</span>
                    <div className="answers">
                        {item.q4}
                    </div>
                </div>

                <div><span className="basic-questions">Har du någonsin fått professionell hjälp 
                        för att vägleda dig i din kost? 
                        Berätta gärna om din dieterfarenhet:</span>
                    <div className="answers">
                        {item.q5}
                    </div>
                </div>

                <div><span className="basic-questions">Vad tycker du är den mest utmanande aspekten 
                        med att följa en diet för att hantera diabetes?</span>
                    <div className="answers">
                        {item.q6}
                    </div>
                </div>

                <div><span className="basic-questions">Har du upplevt några diabetesrelaterade 
                        problem på arbetsplatsen?</span>
                    <div className="answers">
                        {item.q7}
                    </div>
                </div>

                <div><span className="basic-questions">Har platsen du arbetar/brukade arbeta gett 
                        dig något diabetesrelaterat stöd? Om ja, beskriv.</span>
                    <div className="answers">
                        {item.q8}
                    </div>
                </div>
                
                <div><span className="basic-questions">Hur bekväm är du med att använda teknik och 
                        mobilappar? Har du någonsin använt en digital app för att hjälpa dig med 
                        diabeteshantering? Om ja, berätta gärna om dina upplevelsen och din erfarenhet, 
                        både positiv och negativ:</span>
                    <div className="answers">
                        {item.q9}
                    </div>
                </div>

                <h2 className="subtitle">GlucoNutris App Frågor</h2>
                
                <div><span className="basic-questions">Vilka egenskaper förväntar du från en app för 
                        diabetespatienter?</span>
                    <div className="answers">
                        {item.qA1}
                    </div>
                </div>

                <div><span className="basic-questions">Vad är den viktigaste aspekten av kosthantering för 
                        diabetes som du vill ha en app för?</span>
                    <div className="answers">
                        {item.qA2}
                    </div>
                </div>

                <div><span className="basic-questions">Skulle du vara intresserat av interaktiva metoder/ spel, 
                        som frågesporter eller trivias, som ett sätt att lära sig om diabetes? Har du kanske 
                        ett eget förslag?</span>
                    <div className="answers">
                        {item.qA3}
                    </div>
                </div>

                <h4 className="sub-subtitle">
                    Hur användbart för dig följande mobilappfunktioner som hjälper dig att hantera din 
                    kost (1- värdelös, 5- utmärkt): 
                </h4>

                <div><span className="basic-questions">Förvärva kunskap om diabetes genom interaktiva metoder. 
                        Betygsätt på skalan från värdelös(1) till utmärkt</span>
                    <div className="answers">
                        {item.qA4r}
                    </div>
                </div>

                <div><span className="basic-questions">Få näringsberäkning av matrecept och dina 
                        personliga kostbehov. Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA5r}
                    </div>
                </div>

                <div><span className="basic-questions">Få din personliga måltidsplan. 
                        Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA6r}
                    </div>
                </div>

                <div><span className="basic-questions">Registrera dina måltider. 
                        Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA7r}
                    </div>
                </div>

                <div><span className="basic-questions">Hålla koll på dina fysiska aktiviteter. 
                        Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA8r}
                    </div>
                </div>

                <div><span className="basic-questions">Att ha online-konsultationer med dietister. 
                        Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA9r}
                    </div>
                </div>

                <div><span className="basic-questions">Få en personlig inköpslista för veckans måltider. 
                        Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA10r}
                    </div>
                </div>

                <div><span className="basic-questions">Få ett veckans menyförslag med recept. 
                        Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA11r}
                    </div>
                </div>

                <div><span className="basic-questions">Få tillgång till en receptsamling. 
                            Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA12r}
                    </div>
                </div>

                <div><span className="basic-questions">Hålla koll på blodsockermätningar. 
                            Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA13r}
                    </div>
                </div>

                <div><span className="basic-questions">Spåra puls och blodtryck. 
                            Betygsätt på skalan från värdelös(1) till utmärkt(5)</span>
                    <div className="answers">
                        {item.qA14r}
                    </div>
                </div>

                <div><span className="basic-questions">Vill du ha en app som ger dig alternativ för olika dieter (t.ex. medelhavsdiet, 
                            keto-diet, hel mat diet, glutenfri kost, vegetarisk kost) eller en som skräddarsyr 
                            en måltidsplan baserat på dina personliga preferenser?</span>
                    <div className="answers">
                        {item.qA15}
                    </div>
                </div>

                <h4 className="sub-subtitle">
                    Vi vill också veta din åsikt om följande: 
                </h4>

                <div><span className="basic-questions">Vill du ha möjlighet att enkelt hitta och 
                        välja måltider med ett minimalt antal ingredienser eller snabb tillagningstid?</span>
                    <div className="answers">
                        {item.qA16}
                    </div>
                </div>

                <div><span className="basic-questions">Vill du ha en möjlighet att gå med i en grupp 
                        i appen där du kan prata med andra som har diabetes och få hjälp av 
                        vårdexperter?</span>
                    <div className="answers">
                        {item.qA17}
                    </div>
                </div>

                <div><span className="basic-questions">Tror du att ett belöningsprogram skulle vara nyttig 
                            för att hålla dig på rätt spår med din dietplan? Som belöning kan det vara t.ex. 
                            presenter, rabatter på träningsutrustning eller ytterligare konsultationer med 
                            dietister eller kanske du har egna förslag?</span>
                    <div className="answers">
                        {item.qA18}
                    </div>
                </div>

                <div><span className="basic-questions">Skulle det vara intressant för dig att schemalägga 
                        regelbundna incheckningar med en dietist via appen?</span>
                    <div className="answers">
                        {item.qA19}
                    </div>
                </div>

                <div><span className="basic-questions">Vilken typ av hjälp från en digital hälsoapp som 
                        underlättar dig hantera diabetes genom kost, skulle göra dig mer benägen att hålla 
                        fast vid livsstilsförändringar?</span>
                    <div className="answers">
                        {item.qA20}
                    </div>
                </div>

                <div><span className="basic-questions">Skulle du få njuta av en funktion som möjliggör för 
                        användare att skapa och dela med andra sina egna maträttrecept? Med den extra 
                        fördelen att recepten granskas av en dietist innan de publiceras? Och hur tror du 
                        att den här funktionen skulle hjälpa till att hålla användarna engagerade i 
                        applikationen?</span>
                    <div className="answers">
                        {item.qA21}
                    </div>
                </div>

                <div><span className="basic-questions">Vilka specifika funktioner i appen skulle du vara 
                        villig att betala för?</span>
                    <div className="answers">
                        {item.qA22}
                    </div>
                </div>

                <div><span className="basic-questions">Finns det något annat du vill dela med oss?</span>
                    <div className="answers">
                        {item.qA23}
                    </div>
                </div>

            </div>
            ))}
            <h2 className="patient-placeholder">PLACEHOLDER</h2>
        </>
    )
}

export default PatientSV